export interface TrackingProperties {
  // Any used here because this type is used in multiple scenarios
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface TrackingData {
  name: string;
  properties?: TrackingProperties;
}

export abstract class BaseReporter {
  static identify: (userUUID: string, properties: TrackingProperties) => void;
  static initialize: () => void;
  static reset: () => void;
  static screen: (to: string, properties: TrackingProperties) => void;
  static track: (name: string, properties: TrackingProperties) => void;
}
